import LegalDocumentPage from "./LegalDocumentPage";
import { shippingDocument } from "./legalDocumentContent";

const ShippingDelivery = () => {
  return <LegalDocumentPage document={shippingDocument} />;
};

export default ShippingDelivery;